export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#050914]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="inline-block w-8 h-8 border border-[#d4af37] rotate-45 relative">
                <span className="absolute inset-1 bg-[#d4af37]/20" />
              </span>
              <span className="font-serif-editorial text-xl tracking-tight text-white leading-none">
                Richmond <span className="text-[#d4af37]">Holdings</span>
              </span>
            </div>
            <p className="mt-6 text-slate-400 max-w-sm leading-relaxed">
              A minority-owned business consulting firm delivering strategic advisory
              and federal execution, coast to coast.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">
              Explore
            </p>
            <ul className="space-y-3 text-sm text-slate-300">
              <li><a href="#about" className="link-gold">About</a></li>
              <li><a href="#services" className="link-gold">Services</a></li>
              <li><a href="#logistics" className="link-gold">Logistics</a></li>
              <li><a href="#founder" className="link-gold">Founder</a></li>
              <li><a href="#locations" className="link-gold">Locations</a></li>
              <li><a href="#contact" className="link-gold">Contact</a></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">
              Headquarters
            </p>
            <p className="text-slate-300 text-sm leading-relaxed">
              Richmond, Virginia
              <br />
              United States
            </p>
            <p className="mt-4 text-slate-300 text-sm">
              <a
                href="mailto:contact@richmondhg.com"
                className="link-gold"
                data-testid="footer-email"
              >
                contact@richmondhg.com
              </a>
            </p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[11px] uppercase tracking-[0.26em] text-slate-500">
            © {new Date().getFullYear()} Richmond Holdings Group Inc. · All rights reserved.
          </p>
          <p className="text-[11px] uppercase tracking-[0.26em] text-slate-500">
            Minority-Owned · Federal Consulting
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
